module.exports = __webpack_public_path__ + "media/images/favicon/android-chrome-256x256-9cc526b37b245b1878bd17e07155a53b.png";